var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListTicket',{attrs:{"assistenza":_vm.assistenza}})
}
var staticRenderFns = []

export { render, staticRenderFns }